import { ApiError } from "../presentation/interfaces/api-error.interface";

export interface ErrorHandlerParams {
    error: unknown;
    handleLogout: () => void;
    setNotification: (notification: {
        type: 'error';
        message: string
    }) => void;
    defaultErrorMessage?: string;
}

export function createApiError(errorData: unknown, statusCode: number): ApiError {
    // Extract message data
    const message = (
        (typeof errorData === 'object' && errorData !== null)
            ? (errorData as { message?: string }).message
            : undefined
    ) || 'API request failed';

    const error = new Error(message) as ApiError;
    error.statusCode = statusCode;
    error.data = errorData;
    return error;
}

export function normalizeToApiError(error: unknown): ApiError {
    if (typeof error === 'object' && error !== null && 'statusCode' in error) {
        const statusCode = (error as { statusCode: unknown }).statusCode;
        if (typeof statusCode === 'number') {
            return createApiError(error, statusCode);
        }
    }

    if (error instanceof Error) {
        return createApiError(
            { message: error.message, stack: error.stack },
            500
        );
    }
    // For any other case
    return createApiError(error, 500);
}




export function handleApiError({ error, handleLogout, setNotification }: ErrorHandlerParams): void {
    const defaultErrorMessage = 'Failed to load data';
    const apiError = normalizeToApiError(error);
    if (apiError.statusCode === 403) {
        handleLogout();
    }
    setNotification({
        type: 'error',
        message: apiError.message || defaultErrorMessage
    });
}